import { useQueryForm } from '@/services/form/queries'
import { FormItem, FormSettingsType } from '@/types/form'
import { createContext, useState } from 'react'
import { StringParam, useQueryParam } from 'use-query-params'

/* eslint-disable react-refresh/only-export-components -- context module */

export type FormContextType = {
    state: FormItem[]
    setState: React.Dispatch<React.SetStateAction<FormItem[]>>
    showSettings: boolean
    setShowSettings: React.Dispatch<React.SetStateAction<boolean>>
    isDragging: boolean
    setIsDragging: React.Dispatch<React.SetStateAction<boolean>>
    settings: FormSettingsType
    setSettings: React.Dispatch<React.SetStateAction<FormSettingsType>>
    isLoading: boolean
    isFetching: boolean
    processingAudio: Record<string, boolean>
    setProcessingAudio: React.Dispatch<React.SetStateAction<Record<string, boolean>>>
}

const defaultFormContext: FormContextType = {
    state: [],
    setState: () => {},
    showSettings: false,
    setShowSettings: () => {},
    settings: {
        title: '',
        active: true,
        scope: 'public',
        description: '',
        formType: '',
        confirmation_emails: '',
    },
    setSettings: () => {},
    isLoading: false,
    isFetching: false,
    processingAudio: {},
    setProcessingAudio: () => {},
    isDragging: false,
    setIsDragging: () => {},
}

export const FormContext = createContext<FormContextType>(defaultFormContext)

export default function FormContextProvider({ children }: { children: React.ReactNode }) {
    const [form] = useQueryParam('form', StringParam)
    const [state, setState] = useState<FormItem[]>([])
    const [showSettings, setShowSettings] = useState(false)
    const [isDragging, setIsDragging] = useState(false)
    const [settings, setSettings] = useState<FormSettingsType>({
        title: '',
        active: true,
        scope: 'public',
        description: '',
        formType: '',
        confirmation_emails: '',
    })
    const [processingAudio, setProcessingAudio] = useState<Record<string, boolean>>({})

    const { isLoading, isFetching } = useQueryForm({
        enabled: !!form,
        queryParams: {
            id: form as string,
        },
        onSuccess: data => {
            setSettings({
                title: data.title,
                active: data.active,
                scope: data.scope,
                description: data.description,
                formType: data.formType,
                confirmation_emails: data.confirmation_emails,
            })
            setState(data.content)
        },
    })

    return (
        <FormContext.Provider
            value={{
                state,
                setState,
                showSettings,
                setShowSettings,
                settings,
                setSettings,
                isLoading,
                isFetching,
                processingAudio,
                setProcessingAudio,
                isDragging,
                setIsDragging,
            }}
        >
            {children}
        </FormContext.Provider>
    )
}
